<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.uploads.title' | translate"
  [description]="'organizer.edit.uploads.description' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="uploads.dirty"
  [hasInitialValue]="hasInitialValue"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  (submitted)="updateUploads()"
>
  <app-form-input-group
    [label]="'a11y.organizer.edit.uploads.label' | translate"
    [isHiddenLabel]="true"
    [errorKey]="'edit.uploads'"
    [errors]="getErrors()"
    class="block mb-1"
  >
    <app-upload-list
      #content
      [formControl]="uploads"
      [uploadCollection]="uploadCollection"
      [acceptedMimeTypes]="[mimeType.PDF]"
    >
    </app-upload-list>
  </app-form-input-group>
</app-organizer-shared-layout-edit-field>
